const state = {
    competitors: []
};

const mutations = {
    setCompetitors(state, value) {
        state.competitors = value;
    },
};

const actions = {};

const getters = {
    competitors: (state) => state.competitors,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
